<template>
  <div class="search_more_input" v-click-outside="onClick">
      <input type="text" v-model.trim="custom" class="search_more_input_custom" placeholder="请输入学校名称进行搜索" @input="querySearch">
      <div class="search_more_input_dropdown" v-show="dropdownShow">
         <div class="scroll-height"  ref="scroll">
            <ul class="search_more_input_dropdown_list">
               <li class="search_more_input_dropdown_item" v-for="item in list" :key="item.id" @click="choiceTag(item)">{{item.name}}</li>
            </ul>
         </div>

      </div>
   </div>
</template>

<script>
import { _schoolSearch } from "../../api/home";
import BScroll from "better-scroll";
export default {
   name:'search-more',
   data () {
      return {
         custom:"", // 学校名称
         dropdownShow:false, // 学校下拉列表默认不展示
         list:[], // 学校下拉列表
      }
   },
   created() {
   },
   methods:{
      initSroll() {
         if(!this.$refs.scroll){
            return;
         }
         this.bs = new BScroll(this.$refs.scroll,{
            pullUpLoad: true, // 不触发上拉事件
            scrollbar: false, // 展示滚动条
            pullDownRefresh: true, // 开启下拉刷新事件，需要配合内部配置使用，这里目前没有用到
            scrollX:false, // 关闭横向滚动功能
            scrollY:true,
            bounce:false, // 关闭滚动到边缘时的回弹动作
            click:true, // 开启点击事件
            quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
            stopPropagation:true // 内部滑动禁止外部滑动
         })
      },
      // 除下拉框区域之外的点击，受better-scroll影响，目前不生效
      onClick() {
         this.dropdownShow = false
      },
      // 学校名称搜索
      querySearch() {
         _schoolSearch({keywords:this.custom,audit:1}).then(res=>{
            if(res.code == 200){
               this.list = res.data || [];
               if(this.list.length > 0){
                  this.dropdownShow = true;

               }else{
                  this.dropdownShow = false
               }
                setTimeout(() => {
                     this.initSroll()
                  }, 200);
            }
         })
      },
      // 选择学校
      choiceTag(val) {
         this.custom = val.name;
         this.$emit('change',{label:val.name,value:val.schoolCode})
         setTimeout(()=>{
            this.dropdownShow = false;
         },18)
      }
   },
}
</script>

<style lang="scss" scoped>
.search_more_input{
   width:100%;
   height:100%;
   position:relative;
   .search_more_input_custom{
      width:100%;
      height:24px;
      line-height:24px;
      padding:0 8px;
      color:#FFF6D4;
      font-size:12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight:500;
      background: #d99649;
      border-radius:8px;
      border:1px solid transparent;
      box-sizing: border-box;
      box-shadow: 0 1px 0 0 #FFF5D9,0 -1px 1px 0 rgba(0,0,0,0.5);
      // color:#FFF6D4;
      &::placeholder{
         color:#FFF6D4;
      }
   }
   .search_more_input_dropdown{
      width:100%;
      height:155px;
      border-radius:8px;
      background:#fff;
      box-shadow:0px -2px 4px 0px rgba(201,201,201,0.5);
      position: absolute;
      top:34px;
      left:0;

      // left:50%;
      // margin-left:-56px;
      z-index:101;
      .scroll-height{
         height:100%;
         overflow: hidden;
      }
      .search_more_input_dropdown_list{
         text-align: left;
         // height:100%;
         height:auto;
         padding:3px 0;
         overflow-x: scroll;
         padding:3px 0;
      }
      .search_more_input_dropdown_item{
         width:100%;
         padding:3px 8px;
         line-height:21px;
         background: transparent;
         &::after{
            border-color:transparent;
         }
         &:not(:last-child){
            margin-bottom:3px;
         }
         color:#666;
         &:hover{
             color:#fff;
            background: #ff8340;
         }
      }
   }

}
</style>
